// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dx-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 0;
  height: 100%;
}

.dx-form__context {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #F8FAFC;
  flex-shrink: 0;
}

.dx-form__context-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.dx-form__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #BAE6FD;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.dx-form__context-name {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.dx-form__context-code {
  font-weight: 400;
  color: #64748B;
  font-size: 11px;
}

.dx-form__context-meta {
  margin: 2px 0 0;
  font-size: 11px;
  color: #64748B;
  line-height: 1.3;
}

.dx-form__context-badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.dx-form__body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

.dx-form__card {
  position: relative;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex-shrink: 0;
}

.dx-form__card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.dx-form__card-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748B;
}

.dx-form__card-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #0EA5E9;
  flex-shrink: 0;
}

.dx-form__card-index {
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #94A3B8;
}

.dx-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.dx-form__field-label {
  font-size: 13px;
  font-weight: 500;
  color: #334155;
  line-height: 1.25;
}

.dx-form__required {
  color: #F43F5E;
  margin-inline-start: 2px;
}

.dx-form__input-wrap {
  position: relative;
}

.dx-form__input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94A3B8;
  font-size: 16px;
  pointer-events: none;
}

[dir='rtl'] .dx-form__input-icon {
  left: auto;
  right: 12px;
}

.dx-form__input,
.dx-form__select,
.dx-form__textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #0F172A;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.4;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}

.dx-form__input,
.dx-form__select {
  height: 36px;
  padding: 0 12px;
}

.dx-form__input--with-icon {
  padding-inline-start: 36px;
}

.dx-form__textarea {
  min-height: 72px;
  padding: 10px 12px;
  resize: vertical;
}

.dx-form__input:focus,
.dx-form__select:focus,
.dx-form__textarea:focus {
  outline: none;
  border-color: #0EA5E9;
  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.18);
}

.dx-form__input::placeholder,
.dx-form__textarea::placeholder {
  color: #94A3B8;
}

.dx-form__hint {
  margin: 0;
  font-size: 11px;
  color: #64748B;
  line-height: 1.35;
}

.dx-form__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

@media (max-width: 420px) {
  .dx-form__grid {
    grid-template-columns: 1fr;
  }
}

.dx-form__status {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  font-size: 12px;
  font-weight: 600;
  color: #047857;
}

.dx-form__status-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #10B981;
  flex-shrink: 0;
}

.dx-form__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: auto;
  padding-top: 4px;
  flex-shrink: 0;
}

.dx-form__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  border: 1px solid transparent;
  white-space: nowrap;
}

.dx-form__btn--ghost {
  border-color: #E2E8F0;
  background: #ffffff;
  color: #334155;
}

.dx-form__btn--ghost:hover {
  background: #F8FAFC;
  color: #0F172A;
}

.dx-form__btn--primary {
  border-color: #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);
}

.dx-form__btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.dx-form__error {
  margin: 0;
  font-size: 12px;
  color: #DC2626;
  flex-shrink: 0;
}

/* Legacy class kept so older tests / selectors still resolve */
.diagnose-form-part {
  height: 100%;
  min-height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/Diagnoses/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,6EAA6E;EAC7E,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,0DAA0D;AAC5D;;AAEA;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,YAAY;EACZ,aAAa;AACf","sourcesContent":[".dx-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 0;\n  height: 100%;\n}\n\n.dx-form__context {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #F8FAFC;\n  flex-shrink: 0;\n}\n\n.dx-form__context-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.dx-form__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid #BAE6FD;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.dx-form__context-name {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.dx-form__context-code {\n  font-weight: 400;\n  color: #64748B;\n  font-size: 11px;\n}\n\n.dx-form__context-meta {\n  margin: 2px 0 0;\n  font-size: 11px;\n  color: #64748B;\n  line-height: 1.3;\n}\n\n.dx-form__context-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 6px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n  font-size: 11px;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.dx-form__body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.dx-form__card {\n  position: relative;\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  flex-shrink: 0;\n}\n\n.dx-form__card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.dx-form__card-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.dx-form__card-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #0EA5E9;\n  flex-shrink: 0;\n}\n\n.dx-form__card-index {\n  font-size: 12px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: #94A3B8;\n}\n\n.dx-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.dx-form__field-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #334155;\n  line-height: 1.25;\n}\n\n.dx-form__required {\n  color: #F43F5E;\n  margin-inline-start: 2px;\n}\n\n.dx-form__input-wrap {\n  position: relative;\n}\n\n.dx-form__input-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94A3B8;\n  font-size: 16px;\n  pointer-events: none;\n}\n\n[dir='rtl'] .dx-form__input-icon {\n  left: auto;\n  right: 12px;\n}\n\n.dx-form__input,\n.dx-form__select,\n.dx-form__textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #0F172A;\n  font-family: inherit;\n  font-size: 13px;\n  line-height: 1.4;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n\n.dx-form__input,\n.dx-form__select {\n  height: 36px;\n  padding: 0 12px;\n}\n\n.dx-form__input--with-icon {\n  padding-inline-start: 36px;\n}\n\n.dx-form__textarea {\n  min-height: 72px;\n  padding: 10px 12px;\n  resize: vertical;\n}\n\n.dx-form__input:focus,\n.dx-form__select:focus,\n.dx-form__textarea:focus {\n  outline: none;\n  border-color: #0EA5E9;\n  box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.18);\n}\n\n.dx-form__input::placeholder,\n.dx-form__textarea::placeholder {\n  color: #94A3B8;\n}\n\n.dx-form__hint {\n  margin: 0;\n  font-size: 11px;\n  color: #64748B;\n  line-height: 1.35;\n}\n\n.dx-form__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n@media (max-width: 420px) {\n  .dx-form__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.dx-form__status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  font-size: 12px;\n  font-weight: 600;\n  color: #047857;\n}\n\n.dx-form__status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #10B981;\n  flex-shrink: 0;\n}\n\n.dx-form__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: auto;\n  padding-top: 4px;\n  flex-shrink: 0;\n}\n\n.dx-form__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.dx-form__btn--ghost {\n  border-color: #E2E8F0;\n  background: #ffffff;\n  color: #334155;\n}\n\n.dx-form__btn--ghost:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n.dx-form__btn--primary {\n  border-color: #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.25);\n}\n\n.dx-form__btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.dx-form__error {\n  margin: 0;\n  font-size: 12px;\n  color: #DC2626;\n  flex-shrink: 0;\n}\n\n/* Legacy class kept so older tests / selectors still resolve */\n.diagnose-form-part {\n  height: 100%;\n  min-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
